'use client';
import '@suits/ss-design-system/dist/ss-components/ss-components.css';
import '../globals.scss';

import { FetchErrors, getFetchErrors } from '@susu/custom-made/app/configurator/fetchErrors';
import { ButtonType } from '@susu/custom-made/components/button/button';
import Modal from '@susu/custom-made/components/modal/modal';
import { ERROR_TEST_IDS } from '@susu/custom-made/utils/testIds';
import { useI18N } from '@susu/i18n/client';

export default function Error({
  error,
}: Readonly<{
  error: Error & { digest?: string };
}>) {
  const { t } = useI18N();
  const fetchErrors = getFetchErrors(t);

  const getErrorType = (message: string) =>
    fetchErrors[message] ?? fetchErrors[FetchErrors.General];

  return (
    <Modal
      isOpen={true}
      title={getErrorType(error.message).title}
      description={getErrorType(error.message).description}
      firstButtonText={getErrorType(error.message).buttonText}
      firstButtonType={ButtonType.Primary}
      onFirstButtonClick={() => {
        getErrorType(error.message).handler();
      }}
      isFullSize={true}
      testId={ERROR_TEST_IDS.MODAL}
    />
  );
}
